module.exports = __webpack_public_path__ + "img/ibs_02.a5014a08.png";